import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SDetailsLayoutContainer = styled.div`
  height: fit-content;

  ${setFlexDFFDC};
`;
